import { defineMessages } from 'react-intl';

export default defineMessages({
  networkShortName: '{name} Network',
  history: 'History',
  changeAddress: 'Change address',
  disconnect: 'Disconnect',
});
